import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getFlatMeterLocations = async () => {
  return await request.get(
    `/Meter/individual_meter_locations`,
    {},
    'При загрузке мест установки счетчика произошла ошибка'
  );
};

const useFlatMeterLocations = (options) =>
  useQuery(getQueryKeys.flatMeterLocations(), getFlatMeterLocations, options);

export default useFlatMeterLocations;
